import { notification } from "antd";
import { useCallback, useState } from "react";
import { useLanguage } from "~/hooks/useLanguage";
import { loginWithCredentials } from "../services/loginWithCredentials";
import { loginDtoToViewModel } from "~/pages/login/helpers/mapper";
import { AuthenticationInput } from "~/pages/login/types/login";
import {
  EXPIRED_PASSWORD_ERROR,
  LoginError,
} from "~/pages/login/constants/error";
import { IntlMessageID } from "~/providers/I18nProvider";

export const useLoginWithCredentials = () => {
  const { formatMessage } = useLanguage();
  const [loading, setLoading] = useState(false);

  const onExecute = useCallback(
    async (input: AuthenticationInput) => {
      setLoading(true);

      try {
        const response = await loginWithCredentials(input);
        if (response != undefined) {
          return {
            success: true,
            data: loginDtoToViewModel(
              response.userCompaniesInfo,
              response.userName,
            ),
          };
        }
        return {
          success: true,
          data: [],
        };
      } catch (error) {
        const errorMessage = (error as Error)?.message;
        const loginError = LoginError[errorMessage];
        if (loginError) {
          notification.error({
            message: formatMessage(loginError.message),
            description: formatMessage(loginError.description as IntlMessageID),
          });
        } else if (errorMessage === EXPIRED_PASSWORD_ERROR) {
          return {
            success: false,
            data: [],
            isExpiredPassword: true,
          };
        } else {
          notification.error({
            message: (error as Error)?.message,
          });
        }
        return {
          success: false,
          data: [],
        };
      } finally {
        setLoading(false);
      }
    },
    [formatMessage],
  );
  return {
    loginWithCredentials: onExecute,
    loginLoading: loading,
  };
};
